export * from "./events";
export * from "./utils/getSessionInfo";
export { reset, getAnonymousId, disableInMemoryStorage } from "./utils/browser";
export { configureAnalytics } from "./utils/config";
export * from "./utils/worker";
export * from "./deviceModeDestinations";
import { flush } from "./flush";
import { identify } from "./identify";
import { page } from "./page";
import { track } from "./track";
const ShiptAnalytics = {
    identify,
    page,
    track,
    flush,
};
export default ShiptAnalytics;
